import React from 'react';

class CTABonus extends React.Component {
  render() {
    return (
      <div className="container-fluid justify-content-center CTA">
        <h2>SIGN UP TODAY FOR EXCLUSIVE LEAGUE ACCESS</h2>
      </div>
    )
  }
}
export default CTABonus;
